import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal2);

const AdminPanelResults = (props) => {
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchResults = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getResults", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBanks(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchResults();
  };

  useEffect(() => {
    getData();
  }, []);

  const changeTableText = (e) => {
    var field = e.currentTarget.attributes.field.value;
    var userId = e.currentTarget.attributes.fieldUID.value;
    var table = "results";

    MySwal.fire({
      title: "Wprowadź nową wartość",
      text: e.currentTarget.attributes.desc.value,
      input: "text",
      inputPlaceholder: e.currentTarget.value,
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz podać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var value = result.value;

        var body = {
          field: field,
          value: value,
          id: userId,
          table: table,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateConfigTable", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeConfigTeam = async (e) => {
    var field = e.currentTarget.attributes.field.value;
    var userId = e.currentTarget.attributes.fieldUID.value;
    var table = "results";

    var model = [];
    model["1"] = "1";
    model["2"] = "2";
    model["1,2"] = "1,2";

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var body = {
          field: field,
          value: result.value,
          id: userId,
          table: table,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateConfigTable", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeConfigRow = async (e) => {
    var userId = e.currentTarget.attributes.fieldUID.value;
    var table = "results";

    var body = {
      id: userId,
      table: table,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteConfigTable", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const insertConfigRow = async (e) => {
    var table = "results";

    var body = {
      table: table,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertConfigTable2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const usersTableFirst = (
    <table id="detailClientTable" className="clients_table">
      <tr>
        <th>Lp.</th>
        <th>Nazwa</th>
        <th>Akcja</th>
      </tr>
      {banks.map((el, index) => (
        <>
          <tr>
            <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
              {index + 1}
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.name}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={""}
                    value={el.name}
                    fieldUID={el.id}
                    field="name"
                    onClick={changeTableText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="sign_aggr"
                desc={""}
                value={el.team}
                fieldUID={el.id}
                field="team"
                onClick={changeConfigRow}
              >
                <FontAwesomeIcon icon={faDeleteLeft} />
              </button>
            </td>
          </tr>
        </>
      ))}
    </table>
  );

  return (
    <>
      <div className="mainContainerPayments">
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            <div
              style={{ width: "100%", marginBottom: "1vh" }}
              className="closeBox"
            >
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <div
              style={{
                height: "5vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Wyniki rozpraw
            </div>
            {usersTableFirst}
            <button
              style={{ marginTop: "2vh", backgroundColor: "green" }}
              className="closeClientButton"
              onClick={insertConfigRow}
            >
              DODAJ
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default AdminPanelResults;
